import { useNavigate, useSearch } from '@tanstack/react-router';

import type { AdsTxtRecordType } from './model';
import {
  parseAdsTxtRecordsRouteSearch,
  serializeAdsTxtRecordsRouteSearch,
} from './adsTxtRecordsRouteSearch';

export function useAdsTxtRecordsRouteFilters() {
  const navigate = useNavigate({ from: '/supply/ads-txt/records' });
  const search = useSearch({ from: '/supply/ads-txt/records' });
  const filter = parseAdsTxtRecordsRouteSearch(search);
  const update = (next: typeof filter) =>
    void navigate({ search: serializeAdsTxtRecordsRouteSearch(next), replace: true });
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setTypes: (types: AdsTxtRecordType[]) => {
      update({ ...filter, types, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
